import { Node } from 'tiptap'

export default class PDFEmbed extends Node {
  get name() {
    return 'pdfEmbed'
  }

  get schema() {
    return {
      attrs: {
        src: {
          default: null,
        },
        width: {
          default: 600,
        },
        height: {
          default: 740,
        },
      },
      draggable: true,
      selectable: true,
      group: 'block',
      parseDOM: [
        {
          tag: 'embed',
          getAttrs: (dom) => ({
            src: dom.getAttribute('src'),
            width: dom.getAttribute('width'),
            height: dom.getAttribute('height'),
          }),
        },
      ],
      toDOM: (node) => [
        'div',
        { class: 'motyro-pdf' },
        [
          'embed',
          {
            src: node.attrs.src,
            width: node.attrs.width,
            height: node.attrs.height,
          },
        ],
      ],
    }
  }

  get view() {
    return {
      props: ['node', 'updateAttrs', 'view'],
      computed: {
        src: {
          get() {
            const src = this.node.attrs.src
            return src
          },
          set(src) {
            this.updateAttrs({ src })
          },
        },
        styles: {
          get() {
            return {
              height: this.node.attrs.height,
              width: this.node.attrs.width,
            }
          },
          set(obj) {
            this.updateAttrs(obj)
          },
        },
      },
      methods: {
        onResize() {
          const height = this.$refs.iframeBox.clientHeight + 2
          const width = this.$refs.iframeBox.clientWidth + 2

          const obj = {
            height,
            width,
          }

          this.styles = obj
        },
        updateSource(event) {
          this.src = event.target.value
        },
      },
      template: `
        <div class="motyro-embed" ref="iframeBox" @mouseup="onResize" :style="{ width: styles.width + 'px', height: styles.height + 'px' }">
          <embed class="motyro-embed__Iframe" :src="src" />
        </div>
      `,
    }
  }

  commands({ type }) {
    return (attrs) => (state, dispatch) => {
      const { selection } = state
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }
}
